<div class="disable-alarm-integration-container">
	@if (!errorSavingChanges) {
		<div>
			<div class="header-container">
				@if (loadingService.isLoading(disableAjaxForCompanyLoadingKey)) {
					<mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
				}
				<h3 i18n="@@disableAlarmIntegrationDialog-disableAlarmIntegrationHeader" class="header-text">
					Disable Alarm Integration?
				</h3>
			</div>
			<mat-divider></mat-divider>
			<mat-dialog-content>
				<div>
					<p i18n="@@disableAlarmIntegrationDialog-thisWill" class="no-margin-bottom body-text">This will:</p>
					<ul>
						<li i18n="@@disableAlarmIntegrationDialog-disableAlarmIntegrationsForCompany" class="body-text">
							Disable all alarm integrations for this Company
						</li>
						<li i18n="@@disableAlarmIntegrationDialog-clearHubIDs" class="body-text">
							Clear all Hub IDs from connected devices
						</li>
						<li i18n="@@disableAlarmIntegrationDialog-removeAlarmPermissions" class="body-text">
							Remove all user-level alarm permissions
						</li>
					</ul>
					<p i18n="@@disableAlarmIntegrationDialog-thisActionCannotBeUndone" class="body-text">
						This action cannot be undone.
					</p>
					<p i18n="@@disableAlarmIntegrationDialog-toRestoreAJAXIntegrationLater" class="body-text">
						To restore AJAX integration later, all devices must be reconnected to their Hub IDs.
					</p>
					<div>
						<span i18n="@@disableAlarmIntegrationDialog-type" class="body-text">Type</span>{{ ' ' }}
						<span class="body-text disable-alarm-text">{{ disableAlarmText }}</span
						>{{ ' ' }}
						<span i18n="@@disableAlarmIntegrationDialog-belowToConfirm" class="body-text">below to confirm.</span>
					</div>
					<mat-form-field
						appearance="outline"
						[hideRequiredMarker]="true"
						subscriptSizing="dynamic"
						class="disable-alarm-input"
					>
						<input
							matInput
							[(ngModel)]="userDisableAlarmTextInput"
							name="disableAlarm"
							data-automation-id="disable-alarm-input"
							[placeholder]="disableAlarmText"
						/>
					</mat-form-field>
				</div>
			</mat-dialog-content>
			<mat-dialog-actions>
				<button
					data-automation-id="loading-confirmation-negative-dialog-button"
					class="removal-small-button"
					(click)="onCloseClicked()"
					i18n="@@disableAlarmIntegrationDialog-cancelButton"
					[disabled]="loadingService.isLoading(disableAjaxForCompanyLoadingKey)"
				>
					Cancel
				</button>
				<button
					data-automation-id="loading-confirmation-positive-dialog-button"
					class="warning-small-button warning-small-button-wider"
					(click)="onConfirmClicked()"
					i18n="@@disableAlarmIntegrationDialog-disableIntegrationButton"
					[disabled]="
						loadingService.isLoading(disableAjaxForCompanyLoadingKey) ||
						!userDisableAlarmTextInput ||
						userDisableAlarmTextInput !== disableAlarmText
					"
				>
					Disable Integration
				</button>
			</mat-dialog-actions>
		</div>
	}

	@if (errorSavingChanges) {
		<div>
			<div class="header-container">
				<h3 i18n="@@disableAlarmIntegrationDialog-errorSavingChangesHeader">Error!</h3>
			</div>
			<mat-divider></mat-divider>
			<mat-dialog-content>
				<div i18n="@@disableAlarmIntegrationDialog-errorSavingChangesDesc" class="body-text">
					Could not save your changes at this time. Please try again.
				</div>
			</mat-dialog-content>
			<mat-dialog-actions>
				<button
					(click)="onCloseClicked()"
					class="warning-small-button warning-small-button-wider"
					i18n="@@disableAlarmIntegrationDialog-errorSavingChangesConfirm"
					data-automation-id="save-changes-dialog-ok-button"
				>
					Ok
				</button>
			</mat-dialog-actions>
		</div>
	}
</div>
